<template>
    <div class="scatter_echart_box" style="height: 293px;">
      <v-chart
          class="scatter_echart"
          :option="options"
          style="width: 100%;height: 290px"
          autoresize
      />
    </div>
</template>
<script>
import { 
  ref,
  watch
} from 'vue'
import { use } from "echarts/core"
import { CanvasRenderer } from "echarts/renderers"
import { BarChart } from "echarts/charts"
import {
    TooltipComponent,
    LegendComponent,
    TitleComponent,
    SingleAxisComponent,
} from "echarts/components"
use([
  CanvasRenderer,
  BarChart,
  LegendComponent,
  TooltipComponent,
  TitleComponent,
  SingleAxisComponent,
]);
import VChart from "vue-echarts"
export default {
    name : 'UniaxialScatterEchart',
    components: {
         VChart
    },
    props: {
       data_list:{
        default:[]
       }
    },
    setup(props){
      const options = ref(null);
      const setOptionsFn = (list)=>{
        let xAxisData = [];
        let series_data = [];
        list.reverse().forEach((item) => {
          xAxisData.push(item.date.slice(4));
          series_data.push(item.ota_num || 0);
        });
        options.value={
          grid:{
            top:10,
            bottom:20
          },
          tooltip:{
            show:true
          },
          xAxis: {
            name: "月份",
            nameLocation: "end",
            data: xAxisData,
            type: "category",
          },
          yAxis: {
              axisLabel: {
                color: "#404248",
                fontSize: 12,
                padding: [0, 0, 0, 0],
              },
          },
          color: [
            {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: '#D876A7' }, // 设置颜色渐变
                { offset: 1, color: '#EEC378' }
              ]
            },
          ],
          series:[
          {
              type: 'bar',
              name:'更新次数',
              z: 10,
              barWidth:15,
              barMinHeight:1,
              label: {
                  show: true,
                  position: 'top'
              },
              data: series_data
          },
          ]
        }
       
      }
      watch(()=>props.data_list,(new_val)=>{
        if(new_val && new_val.length){
          setOptionsFn(JSON.parse(JSON.stringify(new_val)));
        }
      })
      return {
        options
      }
    }
}
</script>